// extracted by mini-css-extract-plugin
export default {"positions":"Positions__positions___3wkQ-"};